import { API_PREFIX, COMPANY_ROUTE } from '@constants'

export const API_ATTACHMENTS_URL = `${COMPANY_ROUTE}attachments/{document_type}/{document_id}/`
export const API_ATTACHMENT_URL = `${API_ATTACHMENTS_URL}{attachment_id}/`
export const API_ATTACHMENT_DOWNLOAD_URL = `${API_ATTACHMENT_URL}download/`

// EXPORT
export const API_BACKGROUND_JOB_EXPORT_EMAIL_URL = `${API_PREFIX}background-job/{hash}`
